<script setup lang="ts">
import { IonInput, IonModal } from '@ionic/vue'
import { ref, watch } from 'vue'
import Logo from '@/assets/logo_without_bg.png'
import { useUserStore } from '@/store/user'
import { userService } from '@/services/user'
import { useToastStore } from '@/store/toast'

interface Props {
  open: boolean
  canDismiss: boolean
}

interface Emits {
  (e: 'close'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const userStore = useUserStore()
const name = ref(userStore.user.userName)
const toastStore = useToastStore()
watch(() => props.open, (val) => {
  if (val) {
    name.value = userStore.user.userName
  }
})

const loading = ref(false)

async function setName() {
  if (name.value && name.value.length) {
    try {
      loading.value = true
      await userService.updateUserInfo(name.value, false)
      toastStore.setToast('Name updated successfully')
      // refresh user info
      await userStore.getUserInfo()
      emit('close')
    }
    catch (err) {
      console.error(err)
    }
    finally {
      loading.value = false
    }
  }
}
</script>

<template>
  <ion-modal
    :is-open="open"
    :initial-breakpoint="1"
    :breakpoints="[0, 1]"
    class="custom-ion-modal"
    :backdrop-dismiss="false"
    :handle="true"
    :can-dismiss="canDismiss"
    @did-dismiss="
      () => {
        emit('close');
      }
    "
    @ion-modal-did-dismiss="
      () => {
        emit('close');
      }
    "
  >
    <div class="flex flex-col items-center pt-6 px-4 pb-8">
      <img :src="Logo" style="width: 80px; height: 80px" alt="logo">
      <p class="text-5 fw-700 color-#fff leading-normal">
        Welcome to Sekai
      </p>
      <p class="text-3.5 fw-400 color-#B8B8B8 leading-normal">
        How we can call you?
      </p>
      <ion-input
        v-model="name"
        class="custom mt-6 px-4 py-3"
        autocomplete="on"
        autocorrect="on"
        autocapitalize="on"
        placeholder="Enter your name"
      />
      <button
        :class="`${name.length === 0 || loading ? 'btn-secondary' : 'btn-primary'} mt-4`"
        :disabled="name.length === 0 || loading"
        @click="() => setName()"
      >
        {{ loading ? 'Updating...' : 'Set Name' }}
      </button>
    </div>
  </ion-modal>
</template>

<style scoped>
textarea {
  resize: none;
}

ion-button {
  --padding: 0;
}
ion-modal {
  --height: auto;
}

ion-input.custom {
  --color: #fff;
  border-radius: 16px;
  background: var(--white-trans-white-4, rgba(255, 255, 255, 0.04));
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  --padding-top: 12px;
  --padding-end: 16px;
  --padding-bottom: 12px;
  --padding-start: 16px;
}

.custom-ion-modal {
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
